import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {StatusData} from '../model/status-data';
import {StatusRepository} from '../repositories/status.repository';

@Injectable()
export class StatusService {

  constructor(
    private statusRepository: StatusRepository,
  ) { }

  public getStatusData(): Observable<StatusData> {
    return this.statusRepository.getStatusData();
  }

}
